export default __webpack_public_path__ + "static/media/secrets-retreat.dec36740.svg";